<template>
  <div class="container">
    <div class="mian">
      <div class="banner">
        <img :src="topPic" alt="" class="bannerMian"/>
        <img :src="iconPic" alt="" class="icon" v-if="iconPic"/>
        <!--        <div class="tips" @click="gocertuficationH5">车主认证攻略</div>-->
      </div>
      <!-- 登录 -->
      <div class="count">
        <div class="city" v-if="showType==1">
          <div class="title">请选择您的所在城市</div>
          <div class="cityBox" @click="showPicker = true">
            <span>{{ city }}</span>
            <img src="../../../assets/img/rightU.png" alt=""/>
          </div>
          <div @click="getCity" class="btn">确认</div>
          <van-popup v-model="showPicker" round position="bottom">
            <van-picker
              show-toolbar
              ref="picker"
              :columns="columns"
              @cancel="showPicker = false"
              @confirm="onConfirm"
              value-key="name"
            />
          </van-popup>
        </div>
        <!-- 车主 -->
        <div class="ticket tickets" v-if="showType==2||showType==4">
          <div @click="changes" class="btn">成为代驾司机</div>
          <div
            class="btnshare"
            @click="popShare()"
          >
            分享好友一起领
          </div>
        </div>
      </div>
      <div class="rule" v-if="content">
        <div class="title">活动规则</div>
        <div v-html="content">{{ content }}</div>
      </div>
    </div>
    <!-- 分享 -->
    <share-list-one
      :params="params"
      :sharePlatformList="sharePlatformList"
      :shareH5Obj="shareH5Obj"
      ref="child"
    ></share-list-one>
  </div>
</template>

<script>
  import JumpApp from '../../../components/common/jumpApp';
  import util from '@/utils/util';
  import ShareListOne from '../../../components/common/shareListOne';
  import {
    getProvinceCity,
  } from '@/apis/activity/ticketUniversal';
  import mobileType from '../../../utils/mobileType';

  export default {
    components: {
      ShareListOne,
      JumpApp,
    },
    props: ['paramsObj', 'allData', 'activityId', 'outreachChannelCode'],
    data() {
      return {
        showType: 1, //1没有城市没有driverId  2有城市没有driverId  3没有城市有driverId  4有城市有driverId
        promotionStatus: 2, //活动信息
        toast: '您已经是代驾司机啦，快去邀请好友获得奖励吧～',
        isShowFrom: false, //h5分享的弹窗
        userInfoDjsj: {},
        userStatus: {},
        cityType: null,
        content: '', //活动信息
        topPic: '',
        bottomPic: '',
        iconPic: '',
        city: '请选择城市',
        cityCode: '',
        showPicker: false,
        columns: [],
        showShare: false, //分享开关
        sharePlatformList: [
          {
            title: '万顺代驾 随叫随到',
            url: window.location.origin, //分享链接-window.location.href
            imgUrl: this.$commonUrl.cos() + '/image/shareDj.png',
            description: '万顺代驾 随叫随到',
            userName: 'gh_abcc55f26797', //小程序原始id
            // path: 'pages/index/index', //小程序路径
            path: 'active/pages/commonWeb/commonWeb', //小程序路径
            miniprogramType: process.env.NODE_ENV === 'production' ? 0 : 2, //小程序 —— 0=正式版，1=测试版，2=体验版
            platformTag: 3, // 1 = QQ好友，2= QQ空间,3= 微信好友，4= 微信朋友圈
            shareType: 2, //分享类型（1=分享H5，2=小程序，3=分享图片）
          },
        ],
        shareH5Obj: {
          shareH5Title: '万顺代驾 随叫随到', // H5分享标题
          shareH5Link: window.location.href, //H5分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          shareH5ImgUrl: this.$commonUrl.cos() + '/image/shareDj.png', // H5分享图标
        },
        h5Jump: 'h5', //判断下载APP或跳转APP(''为空或不传)，还是车主认证h5流程(h5)
        flag: 1,
        shareTitle: '',
        shareImg: '',
      };
    },
    created() {
      console.log(this.allData, 'allDataallDataallDataallData');
      console.log(this.paramsObj, 'paramsObjparamsObjparamsObj');
      this.params = this.paramsObj;
      this.content = this.allData.content;
      this.topPic = this.allData.activitySpreadVo.skinTopImg;
      this.bottomPic = this.allData.activitySpreadVo.skinBottomImg;
      if (this.outreachChannelCode) {
        this.iconPic = this.allData.distributionUrl;
      }

      //分享相关
      if (this.allData.activitySpreadVo.shareTitle) {
        this.sharePlatformList[0].title = this.allData.activitySpreadVo.shareTitle;
      }
      if (this.allData.activitySpreadVo.shareImg) {
        this.sharePlatformList[0].imgUrl = this.allData.activitySpreadVo.shareImg;
      }

      let userInfoDjsj = this.$storage.get('userInfoDjsj');
      if (userInfoDjsj) {
        this.userInfoDjsj = userInfoDjsj;
        if (!this.userInfoDjsj.cityCode && !this.userInfoDjsj.driverId) {
          this.showType = 1;
        } else if (this.userInfoDjsj.cityCode && !this.userInfoDjsj.driverId) {
          this.showType = 2;
        } else if (!this.userInfoDjsj.cityCode && this.userInfoDjsj.driverId) {
          this.showType = 3;
        } else if (this.userInfoDjsj.cityCode && this.userInfoDjsj.driverId) {
          this.showType = 4;
        }
      }
    },
    // watch: {
    //   allData: {
    //     handler(val) {
    //     },
    //     deep: true
    //   }
    // },
    mounted() {
      this.getinfoCode();
    },

    methods: {
      getinfoCode() {
        if (this.activityId) {
          let url;
          let source = this.$route.query.source;
          if (source) {
            url = 'active/pages/commonWeb/commonWeb?activeid=' + this.activityId + '&source=' + source;
          } else {
            url = 'active/pages/commonWeb/commonWeb?activeid=' + this.activityId;
          }
          this.sharePlatformList[0].path = url;
          if (this.outreachChannelCode) {
            url =
              'active/pages/commonWeb/commonWeb?activeid=' +
              this.activityId +
              '&channelid=' +
              this.outreachChannelCode;
            this.sharePlatformList[0].path = source ? (url + '&source=' + source) : url;
          }
        }

        this.provinceCity();
      },
      //成为代驾司机
      changes() {
        this.$emit('setLoginFun');
        // if (this.showType == 2) {
        //   this.$emit('setLoginFun');
        // } else {
        //   if (this.outreachChannelCode) {
        //     this.$toast({
        //       duration: 3000, // 持续展示 toast
        //       message: '恭喜您成功参加活动，请到app store或应用商店下载万顺代驾司机app查看吧～'
        //     });
        //   } else {
        //     if (this.params.platform == 3) {
        //       this.$toast({
        //         duration: 3000, // 持续展示 toast
        //         message: '恭喜您成功参加活动，请到app store或应用商店下载万顺代驾司机app查看吧～'
        //       });
        //     } else {
        //       if (mobileType.isIOS()) {
        //         window.location.href = 'https://apps.apple.com/cn/app/万顺叫车/id1526105345';
        //       } else if (mobileType.isAndroid()) {
        //         window.location.href = 'https://android.myapp.com/myapp/detail.htm?apkName=com.wsecar.designateddriver';
        //       }
        //     }
        //   }
        // }
      },
      //城市
      async provinceCity() {
        let params = { ...this.params };
        params.data = {
          activityId: this.activityId,
        };
        params.data = JSON.stringify(params.data);

        try {
          const data = await getProvinceCity(params);
          if (data.code == 1) {
            this.columns = JSON.parse(data.data).list;
          }
        } catch (error) {
        }
      },

      //选择城市确认
      getCity() {
        if (!this.cityCode) {
          return this.$toast('请选择城市');
        }
        let userInfoDjsj = this.$storage.get('userInfoDjsj');
        console.log(userInfoDjsj, 'userInfoDjsjuserInfoDjsjuserInfoDjsj');
        // userInfoDjsj.cityCode = this.cityCode;
        this.userInfoDjsj.cityCode = this.cityCode;
        this.$storage.setSession('userInfoDjsj', this.userInfoDjsj);
        if (!this.params.driverId) {
          this.$emit('setLoginFun');
        }
      },
      onConfirm(value) {
        let valueArray = this.$refs.picker.getValues();
        this.city = value[1];
        this.cityCode = valueArray[1].code;
        this.showPicker = false;
      },

      //分享弹窗关闭
      closeShow() {
        this.isShowFrom = false;
      },

      //分享
      getShare(showShare) {
        this.showShare = false;
      },
      popShare() {
        if (this.params.params == 4) {
          this.isShowFrom = true;
        } else {
          this.showShare = true;
          this.$refs.child.jumpPage();
        }
      },

      //车主攻略
      gocertuficationH5() {
        this.$router.push({
          name: 'abouteProcess',
        });
      },
    },
  };
</script>
<style lang="less" scoped>
  .container {
    padding-bottom: 1rem;

    .mian {
      width: 100%;

      .banner {
        width: 100%;
        position: relative;

        .bannerMian {
          width: 100%;
        }

        .icon {
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }

        .tips {
          width: 100%;
          position: fixed;
          top: 12px;
          right: 0;
          color: #333;
          font-size: 12px;
          text-align: center;
          width: 86px;
          height: 28px;
          line-height: 28px;
          background: rgba(255, 255, 255, 0.59);
          border-radius: 100px 1px 1px 100px;
        }
      }

      .count {
        width: 335px;
        padding: 10px 6px 10px;
        background: #ffffff;
        box-shadow: 0px 0px 8px 0px rgba(96, 108, 133, 0.08);
        border-radius: 10px;
        margin: 0 auto;
        min-height: 100px;

        .title {
          font-size: 18px;
          font-weight: 600;
          color: #333333;
          line-height: 40px;
          text-align: center;
        }

        .tip {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          line-height: 20px;
          text-align: center;
        }

        .ticket {
          .btn {
            background: #ffbf54;
            width: 284px;
            height: 44px;
            border-radius: 44px;
            color: #fff;
            font-size: 18px;
            font-weight: 600;
            margin: 10px auto;
            text-align: center;
            line-height: 44px;
          }

          .btnshare {
            border: 1px solid #ffbf54;
            box-sizing: border-box;
            width: 284px;
            height: 44px;
            border-radius: 44px;
            font-size: 18px;
            font-weight: 600;
            margin: 0 auto;
            text-align: center;
            line-height: 44px;
            color: #ffbf54;
            margin-bottom: 10px;
          }

          .coupon {
            padding-bottom: 20px;

            .item {
              background: url(../../../assets/img/ticketU.png) no-repeat;
              width: 335px;
              height: 102px;
              margin: 0 auto;
              background-size: 100% 100%;
              margin-top: 6px;

              dt {
                margin-left: 105px;

                b {
                  font-size: 12px;
                  font-weight: 600;
                  color: #333;
                  padding-top: 0.9rem;
                  display: block;
                  margin-bottom: 5px;
                }

                p {
                  font-size: 10px;
                  font-weight: 400;
                  color: #666;
                  padding-top: 0.1rem;
                  display: block;
                  height: 32px;
                  line-height: 16px;
                }

                span {
                  font-size: 10px;
                  font-weight: 400;
                  color: #c9a063;
                  padding-top: 0.1rem;
                  display: block;
                  padding-bottom: 22px;
                }
              }

              dd {
                float: left;
                width: 100px;
                text-align: center;
                font-size: 0.875rem;
                color: #d8af68;
                font-weight: bold;

                b {
                  font-size: 1.875rem;
                  font-weight: bold;
                  color: #d8af68;
                  padding-top: 2.4rem;
                  display: inline-block;
                }

                p {
                  font-size: 11px;
                  font-weight: 400;
                  color: #d8af68;
                  line-height: 16px;
                }
              }
            }
          }
        }

        .nodata {
          p {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            line-height: 20px;
            padding: 20px;
            text-align: center;

            span {
              display: block;
            }
          }

          .btn {
            background: #ffbf54;
            width: 284px;
            height: 44px;
            border-radius: 44px;
            color: #fff;
            font-size: 18px;
            font-weight: 600;
            margin: 0 auto;
            text-align: center;
            line-height: 44px;
            margin-bottom: 20px;
          }
        }

        .city {
          .cityBox {
            width: 258px;
            height: 24px;
            background: #f9f9f9;
            border-radius: 8px;
            margin: 20px auto;
            padding: 13px 11px;
            display: flex;
            justify-content: space-between;

            img {
              width: 20px;
              height: 20px;
            }
          }

          .btn {
            background: #ffbf54;
            width: 284px;
            height: 44px;
            border-radius: 44px;
            color: #fff;
            font-size: 18px;
            font-weight: 600;
            margin: 0 auto;
            text-align: center;
            line-height: 44px;
            margin-bottom: 20px;
          }
        }
      }

      .rule {
        width: 315px;
        padding: 0 16px 20px;
        background: #ffffff;
        box-shadow: 0px 0px 8px 0px rgba(96, 108, 133, 0.08);
        border-radius: 10px;
        margin: 0 auto;
        min-height: 100px;
        font-size: 14px;
        color: #666;
        line-height: 28px;
        margin-top: 16px;

        .title {
          font-size: 18px;
          font-weight: 600;
          color: #333333;
          line-height: 40px;
          text-align: center;
        }
      }
    }

    .delog {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 999;

      .delogMain {
        position: absolute;
        top: 50%;
        left: 50%;
        background: #fff;
        transform: translate(-50%, -50%);
        text-align: center;
        width: 275px;
        height: 260px;
        padding-top: 30px;
        border-radius: 5px;

        .close {
          position: absolute;
          top: 10px;
          right: 10px;
          width: 20px;
          height: 20px;
        }

        img {
          width: 140px;
          height: 140px;
          margin: 0 auto;
          display: block;
          border-radius: 140px;
        }

        p {
          font-size: 14px;
          font-weight: 500;
          color: #666;
          line-height: 22px;
          margin: 20px 0;
        }

        .tips {
          font-size: 16px;
          font-weight: 500;
          color: #333333;
          line-height: 22px;
        }
      }
    }
  }
</style>


